<template>
  <div>
    <v-container fluid>
      <!-- <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" justify="right">
          <locale-changer class="float-right"/>
        </v-col>
      </v-row> -->
      <v-row
        align="center"
        justify="center"
      >
        <v-col>
          <v-row
            align="center"
            justify="center"
            class="pa-6"
          >
            <v-card
              class="mx-auto"
              min-width="450px"
            >
              <v-card-text class="pa-8 text-center headline h1">
                {{ $t('login.welcomeTo') }}
                <p>
                <img src="@/assets/logo.webp" class="rai-logo"/>
                </p>
              </v-card-text>
              <v-card-text class="pa-8 text-center">
              <p>{{ $t('login.loginToAccessProjects') }}</p>
              <v-text-field
                v-model="email"
                outlined
                :label="$t('global.email')"
                :rules="[rules.required, rules.email]"
                @keyup.enter="login"
              />
              <v-text-field
                v-model="password"
                outlined
                :label="$t('global.password')"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                @keyup.enter="login"
                v-if="!isForgottenPassword"
              />
              <v-text-field
                v-model="newPassword"
                outlined
                :label="$t('login.newPassword')"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-if="isForgottenPassword"
              />
              <v-btn
                class="raison-btn"
                :loading="loginLoading"
                :disabled="!isEmailValid(email) || password.length < 8"
                @click.native="login()"
                v-if="!isForgottenPassword"
              >
                {{ $t('login.signIn') }}
                <template v-slot:loader>
                  <span class="rai-custom-loader__button">
                    <v-icon dark>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <v-text-field
                v-model="code"
                outlined
                :label="$t('login.code')"
                :rules="[rules.required]"
                persistent-hint
                :hint="$t('login.codeSentByMail')"
                v-if="isForgottenPassword"
              />

              <v-btn
                class="raison-btn"
                :loading="loginLoading"
                :disabled="!isEmailValid(email) || newPassword.length < 8 || code.length <= 0"
                @click="resetPassword()"
                v-if="isForgottenPassword"
              >
                {{ $t('login.resetPassword') }}
                <template v-slot:loader>
                  <span class="rai-custom-loader__button">
                    <v-icon dark>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <transition name="shake">
                <p
                  class="subtitle-1 mb-0 mt-1 red--text"
                  v-if="errorMessage"
                >
                  {{ $t('login.error.' + errorMessage) }}
                </p>
              </transition>
              </v-card-text>
              <v-card-text>
                <v-btn
                  class="ma-1"
                  color="error"
                  text
                  x-small
                  @click="sendVerificationCode()"
                  v-if="!isForgottenPassword"
                >
                  {{ $t('login.forgottenPassword') }}
                </v-btn>
                <v-btn
                  class="ma-1"
                  color="error"
                  text
                  x-small
                  @click="goToRegistration()"
                  v-if="!isForgottenPassword"
                >
                  {{ $t('login.register') }}
                </v-btn>
                <v-btn
                  class="raison-btn"
                  @click="isForgottenPassword=false"
                  v-if="isForgottenPassword"
                >
                  {{ $t('global.cancel') }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-row>
          
        </v-col>
      </v-row>
    </v-container>

    <set-new-password-dialog
      :open="openDialog"
      :user="awsUser"
      @cancel="openDialog = false"
    />
  </div>
</template>

<script>
import SetNewPasswordDialog from '@/components/login/SetNewPasswordDialog';
// import LocaleChanger from '@/components/global/LocaleChanger';
import { Auth } from '@aws-amplify/auth';
import { testEmail } from '@/utils/utils.js';

export default {
  name: "LoginPage",

  components: { SetNewPasswordDialog, /* LocaleChanger */ },

  data () {
    return {
      email: '',
      password: '',
      newPassword: '',
      showPassword: false,
      rules: {
        required: value => !!value || this.$i18n.t('login.rules.required'),
        email: value => {
          return testEmail(value) || this.$i18n.t('login.rules.invalidEmail');
        },
      },
      errorMessage: '',
      loginLoading: false,
      openDialog: false,
      awsUser: {},
      isForgottenPassword: false,
      code: '',
    }
  },

  methods: {
    login () {
      this.errorMessage = '';
      this.loginLoading = true;

      Auth.signIn(this.email, this.password).then(user => {
        if (user.challengeName && user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.awsUser = user;
          this.openDialog = true;
        } else {
          this.setcurrentSessionAndRedirect();
        }
      }).catch(err => {
        console.log("Error signing in", err);
        this.errorMessage = err.code;
      }).finally(() => {
        this.loginLoading = false;
      });
    },

    sendVerificationCode() {
      this.loginLoading = true;
      Auth.forgotPassword(this.email)
        .then(() => {
          this.isForgottenPassword = true;
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err.message] });
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },

    resetPassword() {
      this.loginLoading = true;
      // Collect confirmation code and new password, then
      Auth.forgotPasswordSubmit(this.email, this.code, this.newPassword)
          .then(() => {
            this.isForgottenPassword = false;
          })
          .catch(err => {
            this.$emit('raison-event', { type: 'error', messages: [err.message] });
          })
          .finally(() => {
            this.loginLoading = false;
          });
    },

    setcurrentSessionAndRedirect () {
      Auth.currentSession().then(res => {
        this.$store.dispatch('loadCognitoUser', res.getIdToken().payload);
        // TODO: pour l'instant on met dashboard par défaut, mais a l'avenir on pourrra peutetre aller vers l'url initialement demandée
        this.$router.push({name: 'dashboard'});
      }).catch(err => {
        console.log("error : ", err.message);
        this.errorMessage = err.code;
      });
    },

    isEmailValid: testEmail,

    goToRegistration () {
      this.$router.push({ name: 'register' });
    },
  },

  created () {
      // if user is already authenticated, redirect him to dashboard
      Auth.currentAuthenticatedUser()
        .then(() => { this.$router.push({ name: 'dashboard' }) })
        .catch(err => { console.log(err) });
  },
};
</script>

<style>
.shake-enter-active {
  animation: shake .5s;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>